import axios from "axios";
import { Dispatch } from "redux";
import {
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILURE,
  RESET_TEMPLATE,
  TemplateActionTypes,
} from "../types/templateTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const getTemplate =
  (data: any) => async (dispatch: Dispatch<TemplateActionTypes>) => {
    try {
      const response = await API.get("/get-template-by-name", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          name: data.name,
        },
      });

      if (response.status) {
        dispatch({ type: GET_TEMPLATE_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_TEMPLATE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_TEMPLATE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getAllTemplate =
  () => async (dispatch: Dispatch<TemplateActionTypes>) => {
    try {
      const response = await API.get("/get-templates", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: GET_TEMPLATE_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_TEMPLATE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_TEMPLATE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetTemplate =
  () => (dispatch: Dispatch<TemplateActionTypes>) => {
    dispatch({ type: RESET_TEMPLATE });
  };
